import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs';

/**
 * Guard, der nur Zugriff auf den Org-Admin-Client zulässt,
 * wenn ein authentifizierter Org-Admin angemeldet ist.
 */

export const orgAdminClientGuard = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      // allow navigation if authenticated
      return isAuthenticated || router.navigate(['org-admin-client']);
    })
  );
};
